import { SYNC_CONSTS } from "src/config";

export const syncSessionKeys = {
  user: `${SYNC_CONSTS.appUniqueName.sync}${SYNC_CONSTS.skUserSufix}`,
  userPermission: `${SYNC_CONSTS.appUniqueName.sync}${SYNC_CONSTS.skUserPermissionSufix}`,
  userApps: `${SYNC_CONSTS.appUniqueName.sync}${SYNC_CONSTS.skUserAppsSufix}`,
  grantedPermissions: `${SYNC_CONSTS.appUniqueName.sync}${SYNC_CONSTS.skGrantedPermissionsSufix}`,
};

export const syncAuthTokenName =
  SYNC_CONSTS.appUniqueName.sync + SYNC_CONSTS.authTokenSufix;

export const syncSessionBootstrapTombstoneKey = `${SYNC_CONSTS.appUniqueName.sync}-session-bootstrap-blocked`;

export const syncSessionStorageVersionKey = `${SYNC_CONSTS.appUniqueName.sync}-session-schema-version`;
export const syncSessionStorageVersion = "2";
